import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Menu, MenuItem, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteOrders } from '../../../../api/orders';
import { getPendingOrders, updateOrderSelectType, updateSelectedPendingOrders } from '../../../../redux/slices/orders';
import { useDispatch, useSelector } from '../../../../redux/store';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import AwaitButton from "../../../../reusable-components/await-button/AwaitButton";
import DropdownAction from '../../../../reusable-components/dropdown-action/DropdownAction';
import { markMetricRemoved, NotificationMetricType } from '../../../../redux/slices/notifications';

export default function ProcessOrdersButton() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [reason, setReason] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const {
    selectedPendingOrders,
    orderSelectType,
    data: { pendingOrders },
  } = useSelector((state) => state.orders);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleDelete = async () => {
    const ids = selectedPendingOrders;
    const response = await deleteOrders(ids, reason);
    if (response.status === 200) {
      if (response.data > 0) {
        enqueueSnackbar(`${response.data} Orders deleted successfully`, { variant: 'success' });
        dispatch(markMetricRemoved(NotificationMetricType.OrdersSubmitted, ids));
        dispatch(markMetricRemoved(NotificationMetricType.OrdersNeedApproval, ids));
        dispatch(getPendingOrders());
      } else {
        enqueueSnackbar("You don't have permission to delete those orders", { variant: 'error' });
      }
    } else {
      enqueueSnackbar('Failed to delete orders', { variant: 'error' });
    }
    setAnchorEl(null);
    dispatch(updateOrderSelectType(''));
    dispatch(updateSelectedPendingOrders([]));
  };

  const closeMenuDel = (e) => {
    dispatch(updateOrderSelectType(e?.target?.textContent || ''));
    setAnchorEl(null);
  };

  const processInvoices = async () => {
    localStorage.setItem('selectedOrders', JSON.stringify(selectedPendingOrders));

    const nextId = JSON.parse(localStorage.getItem('selectedOrders'))[0];
    navigate(`/dashboard/orders/${nextId}?filter=pending`);
    localStorage.setItem('selectedOrders', JSON.stringify(JSON.parse(localStorage.getItem('selectedOrders')).slice(1)));
    dispatch(updateOrderSelectType(''));
    dispatch(updateSelectedPendingOrders([]));
    setAnchorEl(null);
  };

  const processAllInvoices = () => {
    localStorage.setItem('selectedOrders', JSON.stringify(pendingOrders.map((i) => i.id)));
    const nextId = pendingOrders?.[0]?.id;
    navigate(`/dashboard/orders/${nextId}?filter=pending`);
    dispatch(updateOrderSelectType(''));
    dispatch(updateSelectedPendingOrders([]));
    setAnchorEl(null);
  };

  const cancel = () => {
    localStorage.removeItem('selectedOrders');
    dispatch(updateSelectedPendingOrders([]));
    dispatch(updateOrderSelectType(''));
  };
  const handleCloseConfirm = () => {
    setOpenConfirmDelete(false);
    setReason('');
  };

  return (
    <>
      {orderSelectType !== 'Select Orders to Process' ? (
        <>
          <Button
            size="small"
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
            variant="contained"
            color="secondary"
            endIcon={<ArrowDropDownIcon />}
          >
            Select
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            slotProps={{
              paper: {
                sx: {
                  width: 240,
                  p: 1,
                  borderRadius: '5px',
                  boxShadow: '0px 2px 6px rgba(0,0,0,.06), 0px 8px 24px rgba(0,0,0,.12)',
                },
              },
              list: {
                sx: {
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '14px',
                  p: 0,
                },
              },
            }}
          >
            <MenuItem onClick={closeMenuDel} sx={{ p: 0, minHeight: 'unset' }}>
              <DropdownAction badgeIcon="tabler:checkbox">Select Orders to Process</DropdownAction>
            </MenuItem>
            <MenuItem onClick={processAllInvoices} sx={{ p: 0, minHeight: 'unset' }}>
              <DropdownAction badgeIcon="mdi:arrow-right-circle-outline">Process all orders</DropdownAction>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <Button
            variant="contained"
            size="small"
            sx={{ mr: 1, pr: 5, pl: 5 }}
            color="secondary"
            disabled={pendingOrders?.length === 0}
            onClick={() => {
              processInvoices();
            }}
          >
            Process
          </Button>
          <Button
            variant="outlined"
            size="small"
            sx={{ mr: 1 }}
            color="secondary"
            disabled={true && pendingOrders?.length === 0}
            onClick={() => {
              setOpenConfirmDelete(true);
            }}
          >
            Delete
          </Button>
          <Button size="small" sx={{ textDecoration: 'underline' }} color="secondary" onClick={cancel}>
            Cancel
          </Button>
            <Dialog fullWidth maxWidth="xs" open={openConfirmDelete} onClose={(_, closeMethod) => {
              if (closeMethod === 'backdropClick' || closeMethod === 'escapeKeyDown') return;
              handleCloseConfirm();
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>Delete</DialogTitle>
            <DialogContent>
              <Typography sx={{ typography: 'body2' }}>
                {`Are you sure you want to delete these orders?`}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>Reason</Typography>
              <TextField
                value={reason}
                minRows={2}
                onChange={(event) => setReason(event.target.value)}
                size="small"
                multiline
                fullWidth
                autoComplete="off"
              />
            </DialogContent>
            <DialogActions>
              <AwaitButton
                variant="contained"
                color={'error'}
                  onClick={ async () => {
                    await handleDelete();
                    handleCloseConfirm();
                  }}
              >
                Delete
              </AwaitButton>
              <Button variant="outlined" color="inherit" onClick={handleCloseConfirm}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog> 
        </>
      )}
    </>
  );
}
